import { useEffect, useSyncExternalStore } from 'react';
import axios from 'axios';

/**
 * Interruttori delle funzioni (super admin › Impostazioni › Funzioni).
 *
 * Prima erano variabili di build (.env.development / .env.staging / .env.production) e per
 * cambiarli serviva una build; discipline e traguardi avevano anche un secondo interruttore nel
 * backend, da tenere allineato a mano. Ora li salva il super admin nel backend (GET /features,
 * uno per funzione e per ambiente) e il Manager li legge all'avvio: `useFunzioni()`.
 *
 * Le variabili REACT_APP_FEATURE_* restano solo come valore di partenza, finché il backend non
 * risponde (o se non ha ancora la rotta).
 */
export const isFeatureEnabled = (value) => String(value ?? '').trim().toUpperCase() !== 'N';
const accesoSoloConS = (value) => String(value ?? '').trim().toUpperCase() === 'S';

const DI_PARTENZA = {
    // Opt-out: solo REACT_APP_FEATURE_ASSEMBLEE=N mostra «In arrivo» al posto del modulo
    assemblies: isFeatureEnabled(process.env.REACT_APP_FEATURE_ASSEMBLEE),
    // Opt-in: discipline nuove e traguardi mandano in errore le app vecchie, il default sicuro e` spento
    sportsCatalogCreation: accesoSoloConS(process.env.REACT_APP_FEATURE_SPORT_CATALOG_CREATION),
    moveGoalsManagement: accesoSoloConS(process.env.REACT_APP_FEATURE_MOVE_GOALS),
    purchaseLinks: accesoSoloConS(process.env.REACT_APP_FEATURE_LINK_ACQUISTO),
    newNotificationTypes: false,
};

let correnti = { ...DI_PARTENZA };
let caricamento = null;
const ascoltatori = new Set();

const avvisa = () => ascoltatori.forEach((fn) => fn());

/** Dopo il salvataggio nella pagina Funzioni: il Manager si aggiorna subito. */
export const impostaFunzioni = (funzioni) => {
    correnti = { ...correnti, ...funzioni };
    avvisa();
};

const token = () => {
    try { return JSON.parse(sessionStorage.getItem('userDetails')).idToken; } catch { return ''; }
};

const caricaFunzioni = () => {
    if (caricamento || !token()) return caricamento;
    const base = String(process.env.REACT_APP_API_BASE_PATH || '').replace(/\/+$/, '');
    caricamento = axios
        .get(`${base}/features`, { headers: { authorization: token(), accept: 'application/json' } })
        .then((r) => { if (r?.data && typeof r.data === 'object') impostaFunzioni(r.data); })
        .catch(() => { caricamento = null; }); // si riprova al prossimo componente che le chiede
    return caricamento;
};

const iscrivi = (fn) => {
    ascoltatori.add(fn);
    return () => ascoltatori.delete(fn);
};

/** Gli interruttori dell'ambiente: { assemblies, sportsCatalogCreation, moveGoalsManagement, purchaseLinks, newNotificationTypes }. */
export const useFunzioni = () => {
    useEffect(() => { caricaFunzioni(); }, []);
    return useSyncExternalStore(iscrivi, () => correnti);
};
